import { render } from "./dental_imaging.vue?vue&type=template&id=29fb90c2&scoped=true"
import script from "./dental_imaging.vue?vue&type=script&lang=js"
export * from "./dental_imaging.vue?vue&type=script&lang=js"

import "./dental_imaging.vue?vue&type=style&index=0&id=29fb90c2&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29fb90c2"]])

export default __exports__